import React from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { SITE, getPageMeta } from '../seo.config';

/**
 * Renders per-route metadata. Mounted once inside the Router in App.js.
 *
 * Adds Open Graph and Twitter card tags, which the source site did not have at
 * all — links shared to social or messaging apps previously rendered bare.
 */
const SEO = () => {
  const { pathname } = useLocation();
  const meta = getPageMeta(pathname);

  const canonicalPath = meta.canonical || pathname;
  const canonicalUrl = `${SITE.domain}${canonicalPath}`;
  const imageUrl = `${SITE.domain}${meta.image || SITE.defaultImage}`;
  const description = meta.description || SITE.defaultDescription;

  return (
    <Helmet>
      <title>{meta.title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:locale" content={SITE.locale} />
      <meta property="og:title" content={meta.title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={imageUrl} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={meta.title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      {SITE.twitterHandle ? <meta name="twitter:site" content={SITE.twitterHandle} /> : null}
    </Helmet>
  );
};

export default SEO;
